module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "main-wrapper",
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.ifLogin === false && _vm.loading === false) ? _c('div', [_c('div', [_c('span', [_vm._v("状态：未登录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.robotLogin
    }
  }, [_vm._v("获取登录二维码")])], 1), _vm._v(" "), (_vm.showQrcode) ? _c('div', {
    staticClass: "qrcode-wrapper"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": _vm.qrcodeImage
    }
  }), _vm._v(" "), _c('div', [_vm._v("使用微信扫描上方二维码（长按识别无效），登录微信智能小海。")])]) : _vm._e()]) : (_vm.ifLogin === true) ? _c('div', [_c('div', [_c('span', [_vm._v("用户名：" + _vm._s(_vm.robotInfo.user.NickName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("状态：已登录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.robotLogout
    }
  }, [_vm._v("下线")])], 1), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "微信群管理",
      "name": "wechatGroupTab"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadWechatGroup
    }
  }, [_vm._v("刷新微信群")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.wechatLoading),
      expression: "wechatLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.wechatGroups,
      "stripe": "",
      "border": "",
      "element-loading-text": "正在加载数据"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "name",
      "label": "群名称",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "desc",
      "label": "群描述",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "notice",
      "label": "群公告",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "visible",
      "label": "显示到群导航",
      "formatter": _vm.wechatGroupVisibleFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "激活状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.active === 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("激活")]) : (scope.row.active === 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("禁用")]) : _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("未知")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdateWechatGroupDialog(scope.row)
            }
          }
        }, [_vm._v("更新")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "自动回复设置",
      "name": "autoReplyTab"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddAutoReplyDialog
    }
  }, [_vm._v("添加自动回复")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.autoReplys,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "keyword",
      "label": "关键字"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "reply_type",
      "label": "回复类型",
      "formatter": _vm.autoReplyReplyTypeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "match",
      "label": "匹配方式",
      "formatter": _vm.autoReplyMatchFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "激活状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.active === 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("激活")]) : (scope.row.active === 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("禁用")]) : _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("未知")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "scope",
      "label": "适用范围",
      "formatter": _vm.autoReplyScopeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdateAutoReplyDialog(scope.row)
            }
          }
        }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteAutoReplyDialog(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新微信群",
      "visible": _vm.updateWechatGroupDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.updateWechatGroupDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "autoReplyForm",
    attrs: {
      "model": _vm.wechatGroupForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "群名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.wechatGroupForm.name),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "name", $$v)
      },
      expression: "wechatGroupForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "群描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.wechatGroupForm.desc),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "desc", $$v)
      },
      expression: "wechatGroupForm.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "群公告"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.wechatGroupForm.notice),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "notice", $$v)
      },
      expression: "wechatGroupForm.notice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示到群导航"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.wechatGroupForm.visible),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "visible", $$v)
      },
      expression: "wechatGroupForm.visible"
    }
  }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.wechatGroupForm.visible),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "visible", $$v)
      },
      expression: "wechatGroupForm.visible"
    }
  }, [_vm._v("不显示")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "激活状态"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.wechatGroupForm.active),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "active", $$v)
      },
      expression: "wechatGroupForm.active"
    }
  }, [_vm._v("激活")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.wechatGroupForm.active),
      callback: function($$v) {
        _vm.$set(_vm.wechatGroupForm, "active", $$v)
      },
      expression: "wechatGroupForm.active"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updateWechatGroupDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateWechatGroup
    }
  }, [_vm._v("更 新")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.autoReplyDialogTitle,
      "visible": _vm.autoReplyDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.autoReplyDialogVisible = $event
      },
      "close": _vm.closeAutoReplyDialog
    }
  }, [_c('el-form', {
    ref: "autoReplyForm",
    attrs: {
      "model": _vm.autoReplyForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.autoReplyForm.keyword),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "keyword", $$v)
      },
      expression: "autoReplyForm.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "回复类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.autoReplyForm.reply_type),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "reply_type", $$v)
      },
      expression: "autoReplyForm.reply_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("文字")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("链接")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("图片")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("视频")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 5
    }
  }, [_vm._v("小程序")])], 1)], 1), _vm._v(" "), (_vm.autoReplyForm.reply_type === 1 || _vm.autoReplyForm.reply_type === 2) ? _c('el-form-item', {
    attrs: {
      "label": "回复内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.autoReplyForm.reply),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "reply", $$v)
      },
      expression: "autoReplyForm.reply"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autoReplyForm.reply_type === 3 || _vm.autoReplyForm.reply_type === 4) ? _c('el-form-item', {
    attrs: {
      "label": "视频/图片URL"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.autoReplyForm.media_url),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "media_url", $$v)
      },
      expression: "autoReplyForm.media_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autoReplyForm.reply_type === 5) ? _c('el-form-item', {
    attrs: {
      "label": "小程序标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.autoReplyForm.share_title),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "share_title", $$v)
      },
      expression: "autoReplyForm.share_title"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autoReplyForm.reply_type === 5) ? _c('el-form-item', {
    attrs: {
      "label": "小程序路径"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.autoReplyForm.share_path),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "share_path", $$v)
      },
      expression: "autoReplyForm.share_path"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autoReplyForm.reply_type === 5) ? _c('el-form-item', {
    attrs: {
      "label": "小程序描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.autoReplyForm.share_desc),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "share_desc", $$v)
      },
      expression: "autoReplyForm.share_desc"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autoReplyForm.reply_type === 5) ? _c('el-form-item', {
    attrs: {
      "label": "小程序缩略图"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.autoReplyForm.share_thumb_url),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "share_thumb_url", $$v)
      },
      expression: "autoReplyForm.share_thumb_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "匹配方式"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.autoReplyForm.match),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "match", $$v)
      },
      expression: "autoReplyForm.match"
    }
  }, [_vm._v("全字匹配")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.autoReplyForm.match),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "match", $$v)
      },
      expression: "autoReplyForm.match"
    }
  }, [_vm._v("包含匹配")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "激活状态"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.autoReplyForm.active),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "active", $$v)
      },
      expression: "autoReplyForm.active"
    }
  }, [_vm._v("激活")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.autoReplyForm.active),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "active", $$v)
      },
      expression: "autoReplyForm.active"
    }
  }, [_vm._v("禁用")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用范围"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.autoReplyForm.scope),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "scope", $$v)
      },
      expression: "autoReplyForm.scope"
    }
  }, [_vm._v("仅用户")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.autoReplyForm.scope),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "scope", $$v)
      },
      expression: "autoReplyForm.scope"
    }
  }, [_vm._v("仅群")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    },
    model: {
      value: (_vm.autoReplyForm.scope),
      callback: function($$v) {
        _vm.$set(_vm.autoReplyForm, "scope", $$v)
      },
      expression: "autoReplyForm.scope"
    }
  }, [_vm._v("全部适用")])], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeAutoReplyDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.autoReplyDialogMode === 'add') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAutoReply
    }
  }, [_vm._v("添 加")]) : _vm._e(), _vm._v(" "), (_vm.autoReplyDialogMode === 'update') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAutoReply
    }
  }, [_vm._v("更 新")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("微信智能小海")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b331a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/index.vue
// module id = 805
// module chunks = 1